// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─────────────────────────────────────────────────────────────
   Toast · seal-on-paper notifications
   Families: semantic · action/undo · loading/promise · progress
   Color only ever lives in the glyph chip, the progress bar and the
   timer rule; the body stays ink-text on the ink-dark seal.
   ───────────────────────────────────────────────────────────── */

.toast {
  position: relative;
  overflow: hidden;
  background: var(--ink-dark);
  color: var(--ink-text);
  padding: 12px 14px;
  border: 1px solid rgba(242, 227, 181, 0.07);
  border-radius: var(--r-data);
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: var(--fs-ui);
  box-shadow:
    inset 0 1px 0 rgba(242, 227, 181, 0.06),
    0 12px 32px rgba(8, 12, 28, 0.38);
}

.toast--block {
  align-items: flex-start;
}

/* ── Glyph chip (semantic carrier) ── */
.toast__ico {
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-full);
  font-family: var(--mono);
  font-size: var(--fs-sm);
  flex-shrink: 0;
}
.toast--block .toast__ico {
  margin-top: 1px;
}
.toast--success .toast__ico {
  background: var(--ok);
  color: #fff;
}
.toast--warn .toast__ico {
  background: var(--warn);
  color: #fff;
}
.toast--danger .toast__ico {
  background: var(--danger);
  color: #fff;
}
.toast--info .toast__ico {
  background: var(--cream);
  color: var(--ink-dark);
}
.toast--loading .toast__ico {
  background: transparent;
}

/* ── Body ── */
.toast__grow {
  flex: 1;
  min-width: 0;
  line-height: 1.45;
}
.toast__title {
  font-weight: 500;
  color: var(--ink-text);
  letter-spacing: -0.005em;
}
.toast__desc {
  display: block;
  margin-top: 3px;
  font-size: var(--fs-meta);
  color: var(--ink-text-2);
  line-height: 1.45;
}

/* ── Actions ── */
.toast__action {
  color: var(--cream);
  font-size: var(--fs-meta);
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  font-family: inherit;
  font-weight: 500;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.toast__action:hover {
  color: #fff1c9;
}
.toast__action--ghost {
  color: var(--ink-text-3);
}
.toast__action--ghost:hover {
  color: var(--ink-text);
}
.toast__kbd {
  font-family: var(--mono);
  font-size: var(--fs-micro);
  background: rgba(242, 227, 181, 0.16);
  border: 1px solid rgba(242, 227, 181, 0.3);
  border-radius: 2px;
  padding: 2px 5px;
  color: var(--cream);
}

.toast__dismiss {
  color: rgba(242, 227, 181, 0.55);
  font-family: var(--mono);
  font-size: var(--fs-sm);
  letter-spacing: 0.04em;
  cursor: pointer;
  background: none;
  border: none;
  padding: 2px 4px;
  flex-shrink: 0;
}
.toast__dismiss:hover {
  color: var(--cream);
}

.toast__sep {
  width: 1px;
  align-self: stretch;
  background: var(--ink-rule);
  margin: -2px 0;
  flex-shrink: 0;
}

/* ── Loading spinner ── */
.toast__spin {
  width: 16px;
  height: 16px;
  border-radius: var(--radius-full);
  border: 2px solid var(--ink-rule);
  border-top-color: var(--cream);
  animation: toast-spin 0.7s linear infinite;
}
@keyframes toast-spin {
  to {
    transform: rotate(360deg);
  }
}

/* ── Progress bar (Carga Masiva) ── */
.toast__bar {
  margin-top: 9px;
  height: 5px;
  width: 100%;
  background: var(--ink-rule-soft);
  border-radius: var(--radius-full);
  overflow: hidden;
}
.toast__bar > i {
  display: block;
  height: 100%;
  background: linear-gradient(90deg, var(--signal), var(--cyan));
  border-radius: var(--radius-full);
  transition: width 0.3s ease;
}
.toast__bar.done > i {
  background: var(--ok);
}
.toast__metarow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
  font-family: var(--mono);
  font-size: var(--fs-eyebrow);
  letter-spacing: 0.04em;
  color: var(--ink-text-3);
}
.toast__metarow .count {
  color: var(--cream);
}

/* ── Auto-dismiss timer rule (semantic) ── */
.toast__timer {
  position: absolute;
  left: 0;
  bottom: 0;
  height: 2px;
  width: 100%;
  border-bottom-left-radius: var(--r-data);
  animation-name: toast-timer;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
}
.toast--success .toast__timer {
  background: var(--ok);
}
.toast--warn .toast__timer {
  background: var(--warn);
}
.toast--danger .toast__timer {
  background: var(--danger);
}
.toast--info .toast__timer {
  background: var(--cream);
}
@keyframes toast-timer {
  from {
    width: 100%;
  }
  to {
    width: 0%;
  }
}

/* ── Entrance — quiet slide from the right + fade, deceleration easing ── */
@keyframes toast-in {
  from {
    opacity: 0;
    transform: translateX(16px) scale(0.99);
  }
  to {
    opacity: 1;
    transform: none;
  }
}

/* ── Provider container — bottom-right; clearance is published by whoever
   owns that corner (see FeedbackWidget). No occupant → fallback 24px. ── */
.toast-provider {
  position: fixed;
  right: 24px;
  bottom: var(--corner-clearance, 24px);
  z-index: var(--z-toast, 2000);
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 380px;
  max-width: calc(100vw - 48px);
  align-items: flex-end;
  pointer-events: none;
  transition: bottom 0.35s cubic-bezier(0.16, 1, 0.3, 1);
}
.toast-provider .toast {
  width: 100%;
  pointer-events: all;
  animation: toast-in 0.26s cubic-bezier(0.16, 1, 0.3, 1) both;
}

@media (prefers-reduced-motion: reduce) {
  .toast-provider .toast {
    animation: none;
  }
  .toast__timer {
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/ui/Toast/Toast.css"],"names":[],"mappings":"AAAA;;;;;kEAKkE;;AAElE;EACE,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,sBAAsB;EACtB,kBAAkB;EAClB,2CAA2C;EAC3C,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB;;qCAEmC;AACrC;;AAEA;EACE,uBAAuB;AACzB;;AAEA,wCAAwC;AACxC;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,wBAAwB;EACxB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,wBAAwB;EACxB,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;;AAEA,eAAe;AACf;EACE,OAAO;EACP,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,wBAAwB;AAC1B;AACA;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,0BAA0B;EAC1B,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,cAAc;AAChB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,2BAA2B;EAC3B,cAAc;EACd,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,iCAAiC;EACjC,8BAA8B;EAC9B,0CAA0C;AAC5C;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,sCAAsC;AACtC;EACE,eAAe;EACf,WAAW;EACX,WAAW;EACX,gCAAgC;EAChC,iCAAiC;EACjC,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,YAAY;EACZ,8DAA8D;EAC9D,iCAAiC;EACjC,2BAA2B;AAC7B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,wBAAwB;EACxB,4BAA4B;EAC5B,sBAAsB;EACtB,wBAAwB;AAC1B;AACA;EACE,mBAAmB;AACrB;;AAEA,6CAA6C;AAC7C;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,WAAW;EACX,WAAW;EACX,wCAAwC;EACxC,2BAA2B;EAC3B,iCAAiC;EACjC,6BAA6B;AAC/B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;AACF;;AAEA,4EAA4E;AAC5E;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,eAAe;EACjB;AACF;;AAEA;2EAC2E;AAC3E;EACE,eAAe;EACf,WAAW;EACX,qCAAqC;EACrC,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,6BAA6B;EAC7B,qBAAqB;EACrB,oBAAoB;EACpB,sDAAsD;AACxD;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,4DAA4D;AAC9D;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* ─────────────────────────────────────────────────────────────\n   Toast · seal-on-paper notifications\n   Families: semantic · action/undo · loading/promise · progress\n   Color only ever lives in the glyph chip, the progress bar and the\n   timer rule; the body stays ink-text on the ink-dark seal.\n   ───────────────────────────────────────────────────────────── */\n\n.toast {\n  position: relative;\n  overflow: hidden;\n  background: var(--ink-dark);\n  color: var(--ink-text);\n  padding: 12px 14px;\n  border: 1px solid rgba(242, 227, 181, 0.07);\n  border-radius: var(--r-data);\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: var(--fs-ui);\n  box-shadow:\n    inset 0 1px 0 rgba(242, 227, 181, 0.06),\n    0 12px 32px rgba(8, 12, 28, 0.38);\n}\n\n.toast--block {\n  align-items: flex-start;\n}\n\n/* ── Glyph chip (semantic carrier) ── */\n.toast__ico {\n  width: 18px;\n  height: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: var(--radius-full);\n  font-family: var(--mono);\n  font-size: var(--fs-sm);\n  flex-shrink: 0;\n}\n.toast--block .toast__ico {\n  margin-top: 1px;\n}\n.toast--success .toast__ico {\n  background: var(--ok);\n  color: #fff;\n}\n.toast--warn .toast__ico {\n  background: var(--warn);\n  color: #fff;\n}\n.toast--danger .toast__ico {\n  background: var(--danger);\n  color: #fff;\n}\n.toast--info .toast__ico {\n  background: var(--cream);\n  color: var(--ink-dark);\n}\n.toast--loading .toast__ico {\n  background: transparent;\n}\n\n/* ── Body ── */\n.toast__grow {\n  flex: 1;\n  min-width: 0;\n  line-height: 1.45;\n}\n.toast__title {\n  font-weight: 500;\n  color: var(--ink-text);\n  letter-spacing: -0.005em;\n}\n.toast__desc {\n  display: block;\n  margin-top: 3px;\n  font-size: var(--fs-meta);\n  color: var(--ink-text-2);\n  line-height: 1.45;\n}\n\n/* ── Actions ── */\n.toast__action {\n  color: var(--cream);\n  font-size: var(--fs-meta);\n  text-decoration: underline;\n  text-underline-offset: 2px;\n  cursor: pointer;\n  background: none;\n  border: none;\n  padding: 0;\n  font-family: inherit;\n  font-weight: 500;\n  white-space: nowrap;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n.toast__action:hover {\n  color: #fff1c9;\n}\n.toast__action--ghost {\n  color: var(--ink-text-3);\n}\n.toast__action--ghost:hover {\n  color: var(--ink-text);\n}\n.toast__kbd {\n  font-family: var(--mono);\n  font-size: var(--fs-micro);\n  background: rgba(242, 227, 181, 0.16);\n  border: 1px solid rgba(242, 227, 181, 0.3);\n  border-radius: 2px;\n  padding: 2px 5px;\n  color: var(--cream);\n}\n\n.toast__dismiss {\n  color: rgba(242, 227, 181, 0.55);\n  font-family: var(--mono);\n  font-size: var(--fs-sm);\n  letter-spacing: 0.04em;\n  cursor: pointer;\n  background: none;\n  border: none;\n  padding: 2px 4px;\n  flex-shrink: 0;\n}\n.toast__dismiss:hover {\n  color: var(--cream);\n}\n\n.toast__sep {\n  width: 1px;\n  align-self: stretch;\n  background: var(--ink-rule);\n  margin: -2px 0;\n  flex-shrink: 0;\n}\n\n/* ── Loading spinner ── */\n.toast__spin {\n  width: 16px;\n  height: 16px;\n  border-radius: var(--radius-full);\n  border: 2px solid var(--ink-rule);\n  border-top-color: var(--cream);\n  animation: toast-spin 0.7s linear infinite;\n}\n@keyframes toast-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* ── Progress bar (Carga Masiva) ── */\n.toast__bar {\n  margin-top: 9px;\n  height: 5px;\n  width: 100%;\n  background: var(--ink-rule-soft);\n  border-radius: var(--radius-full);\n  overflow: hidden;\n}\n.toast__bar > i {\n  display: block;\n  height: 100%;\n  background: linear-gradient(90deg, var(--signal), var(--cyan));\n  border-radius: var(--radius-full);\n  transition: width 0.3s ease;\n}\n.toast__bar.done > i {\n  background: var(--ok);\n}\n.toast__metarow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 8px;\n  font-family: var(--mono);\n  font-size: var(--fs-eyebrow);\n  letter-spacing: 0.04em;\n  color: var(--ink-text-3);\n}\n.toast__metarow .count {\n  color: var(--cream);\n}\n\n/* ── Auto-dismiss timer rule (semantic) ── */\n.toast__timer {\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  height: 2px;\n  width: 100%;\n  border-bottom-left-radius: var(--r-data);\n  animation-name: toast-timer;\n  animation-timing-function: linear;\n  animation-fill-mode: forwards;\n}\n.toast--success .toast__timer {\n  background: var(--ok);\n}\n.toast--warn .toast__timer {\n  background: var(--warn);\n}\n.toast--danger .toast__timer {\n  background: var(--danger);\n}\n.toast--info .toast__timer {\n  background: var(--cream);\n}\n@keyframes toast-timer {\n  from {\n    width: 100%;\n  }\n  to {\n    width: 0%;\n  }\n}\n\n/* ── Entrance — quiet slide from the right + fade, deceleration easing ── */\n@keyframes toast-in {\n  from {\n    opacity: 0;\n    transform: translateX(16px) scale(0.99);\n  }\n  to {\n    opacity: 1;\n    transform: none;\n  }\n}\n\n/* ── Provider container — bottom-right; clearance is published by whoever\n   owns that corner (see FeedbackWidget). No occupant → fallback 24px. ── */\n.toast-provider {\n  position: fixed;\n  right: 24px;\n  bottom: var(--corner-clearance, 24px);\n  z-index: var(--z-toast, 2000);\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  width: 380px;\n  max-width: calc(100vw - 48px);\n  align-items: flex-end;\n  pointer-events: none;\n  transition: bottom 0.35s cubic-bezier(0.16, 1, 0.3, 1);\n}\n.toast-provider .toast {\n  width: 100%;\n  pointer-events: all;\n  animation: toast-in 0.26s cubic-bezier(0.16, 1, 0.3, 1) both;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .toast-provider .toast {\n    animation: none;\n  }\n  .toast__timer {\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
